import { deriveHybridDuctedSpaceIds } from 'utils/hybrid-config-autobuild';
import { HybridPromptStoreState } from 'utils/hybrid-config-generation-prompt-types';
import { isHybridOnlySystemPreference } from 'utils/project';

export function hybridLeftoverGenerationPromptAppendix(
  leftoverSpaceIds: readonly string[]
): string {
  if (leftoverSpaceIds.length === 0) {
    return '';
  }
  return (
    '\n\nHYBRID LEFTOVER SPACES: The following space unique IDs are the ' +
    'auto-filled leftover remainder of each footprinted level. Ducted ' +
    `zone(s) MUST contain only these spaces: ${leftoverSpaceIds.join(', ')}. ` +
    'User-placed rooms must be ductless. Each leftover/ducted zone MUST ' +
    'include airHandler { abbreviation: DH, spaceUniqueId: <leftover> }. ' +
    'A leftover-only floor is complete: one condenser, one ducted DH ' +
    'zone, and no ductless zone. Do not ask for more rooms and do not ' +
    'use needs_info. Never serve leftover spaces as ductless. Prefer ' +
    'one condenser per conditioned level; add a second condenser on a ' +
    'level only if the 6-zone cap requires it.'
  );
}

export function hybridLeftoverUserPromptSuffix(
  state: HybridPromptStoreState
): string {
  const preference = state.project?.projectSettings?.find(
    (setting) => setting.code === 'system_preference'
  )?.value;
  if (!isHybridOnlySystemPreference(preference)) {
    return '';
  }
  return hybridLeftoverGenerationPromptAppendix(
    deriveHybridDuctedSpaceIds(
      state.structure?.structure ?? [],
      state.structure?.autoLayoutSpaceIds ?? []
    )
  );
}
